module.exports = __webpack_public_path__ + "images/547d06c204010e3e9fe953db9865ba54.png";


//////////////////
// WEBPACK FOOTER
// ./js/components/assets/woman/4.png
// module id = 380
// module chunks = 0